module.exports = __webpack_public_path__ + "static/todo-7603f1804616c154634cc773f1c455c0.png";